import { render, staticRenderFns } from "./StakingModal.vue?vue&type=template&id=68337646&scoped=true"
import script from "./StakingModal.vue?vue&type=script&lang=js"
export * from "./StakingModal.vue?vue&type=script&lang=js"
import style0 from "./StakingModal.vue?vue&type=style&index=0&id=68337646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68337646",
  null
  
)

export default component.exports